import { Injector, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { createCustomElement } from '@angular/elements';
import { SanitizePipeModule } from '@digistore/ds24-ui/pipes';
import { DialogModule } from 'primeng/dialog';
import { NotificationsComponent } from './notifications.component';
import { PipesModule } from '../../pipes/pipes.module';

@NgModule({
  declarations: [NotificationsComponent],
  imports: [CommonModule, SanitizePipeModule, DialogModule, PipesModule],
})
export class NotificationsModule {
  static initialize(injector: Injector) {
    const customComponent = createCustomElement(NotificationsComponent, {
      injector: injector,
    });
    customElements.define('ds-orderform-notifications', customComponent);
  }
}
